export const dummyBankFeedTransactions = [
    {
        id: 1,
        date: '2023-10-04 12:23:34',
        description: 'INSTANT TRSF CR 055418 CLEANAHOLICS SDN BHD INVOICE 000019 PROFESSIONAL FEE',
        // amount: 14.23,
        credit_amount: 14.23,
        debit_amount: null,
    },
    {
        id: 2,
        date: '2023-10-08 12:23:34',
        description: 'Customer Payment - Invoice #INV-0002',
        // amount: 24.23,
        credit_amount: 24.23,
        // debit_amount: 0,
    },
    {
        id: 3,
        date: '2023-10-12 12:23:34',
        description: 'Customer Payment - Invoice #INV-0003',
        // amount: 16.23,
        credit_amount: 16.23,
        debit_amount: 0,
    },
    {
        id: 4,
        date: '2023-10-24 12:23:34',
        description: 'Supplier Payment - Bill #BL-0001',
        // amount: -14.23,
        credit_amount: 0,
        debit_amount: 14.23,
    },
];

// export const dummyBankFeedTransactions = {
//     currency_code: 'MYR',
//     currency_symbol: 'RM',
//     bank_name: 'Maybank',
//     bank_account_name: 'Maybank i-Saver 1241',
//     id: 1,
//     bukku_account_id: 2,
//     bukku_account_name: 'Bank Account',
//     lines: dummyTableData,
// };
